<app-vertical-tab-group>
  <app-vertical-tab
      *ngFor="let treatment of treatments.controls"
      [title]="'Treatment ' + treatment.value.treatmentNumber"
      [hasError]="treatment.get('pottingInstructions').invalid">
    <div>
      <app-potting-instructions-form
      [options]="pottingInstructionsOptions"
      [treatment]="treatment"
      #pottingForm></app-potting-instructions-form>
    </div>

    <div class="text-right">
      <button class="btn btn-default" type="button" (click)="applyAll(pottingForm)">
        Apply to All
      </button>
    </div>
  </app-vertical-tab>
</app-vertical-tab-group>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/potting-instructions/potting-instructions.component.html